import { colors } from '@/theme/colors';

interface SpinnerProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
}

export default function Spinner({
  width = 24,
  height = 24,
  color = colors.neutral60,
  className,
}: SpinnerProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      width={width}
      height={height}
      fill="none"
      role="img"
      className={className ?? 'animate-[spin_1s_linear_infinite]'}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12.0002C2 6.4774 6.47715 2.00024 12 2.00024C12.5523 2.00024 13 2.44796 13 3.00024C13 3.55253 12.5523 4.00024 12 4.00024C7.58172 4.00024 4 7.58197 4 12.0002C4 16.4185 7.58172 20.0002 12 20.0002C16.4183 20.0002 20 16.4185 20 12.0002C20 11.448 20.4477 11.0002 21 11.0002C21.5523 11.0002 22 11.448 22 12.0002C22 17.5231 17.5228 22.0002 12 22.0002C6.47715 22.0002 2 17.5231 2 12.0002Z"
        fill={color}
      />
    </svg>
  );
}
